const DELIMITER = ' | ';
class DurationTrackerImpl {
    constructor() {
        this.transactionStartTimes = {};
        this.phaseStartTimes = {};
    }
    createKey(...args) {
        return args.join(DELIMITER);
    }
    markTransactionStart(fullArtifactId, componentId, transactionName) {
        const key = this.createKey(fullArtifactId, componentId, transactionName);
        this.transactionStartTimes[key] = Date.now();
    }
    markTransactionFinish(fullArtifactId, componentId, transactionName) {
        const key = this.createKey(fullArtifactId, componentId, transactionName);
        const finishTime = Date.now();
        const startTime = this.transactionStartTimes[key] || finishTime;
        const duration = Math.round(finishTime - startTime);
        this.transactionStartTimes[key] = 0;
        return duration;
    }
    markPhaseStart(fullArtifactId, componentId, phaseName) {
        const key = this.createKey(fullArtifactId, componentId, phaseName);
        this.phaseStartTimes[key] = Date.now();
    }
    markPhaseFinish(fullArtifactId, componentId, phaseName) {
        const key = this.createKey(fullArtifactId, componentId, phaseName);
        const finishTime = Date.now();
        const startTime = this.phaseStartTimes[key] || finishTime;
        const duration = Math.round(finishTime - startTime);
        this.phaseStartTimes[key] = 0;
        return duration;
    }
}
export const createDurationTracker = () => new DurationTrackerImpl();
//# sourceMappingURL=duration-tracker.js.map